import React from "react";

import DispensaryMenuItemCardSkeleton from "@/components/DispensaryMenuItemCard/DispensaryMenuItemCardSkeleton";

const MenuItemLoadingSkeleton = ({
  items = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
  ],
}: {
  items?: Array<string>;
}) => (
  <>
    {items.map((n: string) => (
      <DispensaryMenuItemCardSkeleton key={n} />
    ))}
  </>
);

export default MenuItemLoadingSkeleton;
